module.exports = __webpack_public_path__ + "img/infor2.5960a671.png";